import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#0e3d7c',
        secondary: '#003666',
        accent: '#c5911e',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        'gris-10': '#5e5e5f',
      }
    },
  },
    lang: {
      locales: { es },
      current: 'es',
    },
});
